// What an output shows: the processed stream back from the server, or this window's own outgoing stream (client loopback, no server needed).
export { selectOutputInput } from '~/store/outputMapping/selectors'

export const INPUTS = [
	{ input: 'source', label: 'Stage', icon: 'ms/videocam', tip: 'The stage, before processing' },
	{ input: 'output', label: 'Output', icon: 'ms/output', tip: 'The processed output' },
]

const EVENT = { output: 'incoming_stream', source: 'outgoing_stream' }

export const streamOf = input => (input === 'source' ? window.outgoing_stream : window.incoming_stream) ?? null

// Calls `cb(stream)` now and on every replacement; a lost incoming stream is never passed on, so a projection surface holds its last frame.
export function watchInput(input, cb) {
	const run = () => {
		const stream = streamOf(input)
		if (stream || input === 'source') cb(stream)
	}
	cb(streamOf(input))
	window.addEventListener(EVENT[input], run)
	return () => window.removeEventListener(EVENT[input], run)
}
